<template src="./gallery-widget.html"></template>

<script lang="ts">
import { callTurnToConfigFn } from 'util/turnto-utils'
import galleryConfig from './gallery-widget.config'
import galleryStore from 'store/gallery-widget-store'
import Gallery from 'components/gallery/Gallery.vue'
import trackingService from 'services/tracking-service'

export default {
  data() {
    return {
      galleryConfig,
      galleryStore
    }
  },
  components: { 'tt-gallery': Gallery },
  computed: {
    skus() {
      return this.galleryStore.skus
    },
    tags() {
      return this.galleryStore.tags
    }
  },
  methods: {
    onFinish() {
      callTurnToConfigFn('gallery', 'onFinish')
    },
    onLoad() {
      trackingService.queueEvent('gallery', 'load')
    }
  }
}
</script>

